import React from 'react'
import { Box, Typography } from '@mui/material'
import { BoltIcon } from '@heroicons/react/24/outline'
import { INTERAX_COLORS, INTERAX_TYPOGRAPHY } from '../../../../constants/colors'

export interface SessionFeedbackSectionHeaderProps {
  sessionTitle: string
}

export const SessionFeedbackSectionHeader: React.FC<SessionFeedbackSectionHeaderProps> = ({ sessionTitle }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: { xs: 'column', sm: 'row' },
      alignItems: { xs: 'flex-start', sm: 'flex-start' },
      padding: '0px',
      gap: { xs: 1, sm: 2, md: 2 },
      width: '100%',
      minHeight: { xs: 'auto', sm: '48px', md: '48px' },
      flex: 'none',
      order: 0,
      alignSelf: 'stretch',
      flexGrow: 0,
      zIndex: 0
    }}
  >
    <Box
      aria-hidden
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '0px',
        width: { xs: '40px', sm: '48px', md: '48px' },
        height: { xs: '40px', sm: '48px', md: '48px' },
        background: INTERAX_COLORS.sun20,
        borderRadius: '10px',
        flex: 'none',
        order: 0,
        flexGrow: 0,
        flexShrink: 0
      }}
    >
      <BoltIcon
        aria-hidden
        style={{
          width: '24px',
          height: '24px',
          color: INTERAX_COLORS.sun
        }}
      />
    </Box>

    <Typography
      sx={{
        ...INTERAX_TYPOGRAPHY.headline3,
        color: INTERAX_COLORS.white,
        flex: 1,
        order: 1,
        alignSelf: { xs: 'flex-start', sm: 'center', md: 'center' },
        minWidth: 0,
        overflowWrap: 'break-word'
      }}
    >
      {sessionTitle}
    </Typography>
  </Box>
)
